/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `CREATE` - Create
 * * `UPDATE` - Update
 * * `DELETE` - מחיקה
 * * `COMMENT` - Comment
 */
export enum ChangeTypeEnum {
    CREATE = 'CREATE',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
    COMMENT = 'COMMENT',
}
